import React from 'react';
import { motion } from 'framer-motion';
import { Code, Smartphone, Globe, Zap } from 'lucide-react';

const ApplicationDevelopment = () => {
  const services = [
    {
      icon: <Code size={40} />,
      title: 'Custom Software Development',
      description: 'Build scalable, secure, and high-performance custom applications tailored to your business needs.',
      features: ['Full-stack development', 'Microservices architecture', 'API development', 'Legacy modernization']
    },
    {
      icon: <Smartphone size={40} />,
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile applications for iOS and Android with exceptional user experience.',
      features: ['Native iOS/Android', 'React Native', 'Flutter development', 'Progressive Web Apps']
    },
    {
      icon: <Globe size={40} />,
      title: 'Web Application Development',
      description: 'Modern, responsive web applications using cutting-edge technologies and frameworks.',
      features: ['React/Angular/Vue.js', 'Node.js backend', 'Cloud-native design', 'Real-time features']
    },
    {
      icon: <Zap size={40} />,
      title: 'DevOps & Automation',
      description: 'Streamline development processes with CI/CD pipelines and automated deployment strategies.',
      features: ['CI/CD pipelines', 'Infrastructure as Code', 'Automated testing', 'Container orchestration']
    }
  ];

  return (
    <div className="service-page">
      <div className="container">
        <motion.div 
          className="page-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>Application Development Services</h1>
          <p>Build modern, scalable applications with cutting-edge technologies and best practices.</p>
        </motion.div>

        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul>
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ApplicationDevelopment;